import { addIssueLink } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/issue-links';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default { addIssueLink };
